import styles from './IdAnalyzerLoading.module.css';
import { Card } from '../../../../organisms/card';
import Text from '../../../../atoms/typography/Text';
import { ColorEnum, FontSizeEnum, FontWeightEnum } from '../../../../enums';
import { useTranslation } from 'react-i18next';
import screeningSteps from '../../../../organisms/screening-navigation/screeningSteps';
import { classNames } from '../../../../utils';
import { useEffect, useState } from 'react';

const IdAnalyzerLoading = () => {
    const { t } = useTranslation();

    const [ dots, setDots ] = useState<string>('');

    useEffect(() => {
        const interval = setInterval(() => {
            setDots((prevDots) => prevDots.length < 3 ? prevDots + '.' : '');
        } , 500);
        return () => clearInterval(interval);
    }, [])

    return (
        <div className={styles.contentContainer}>
            <div className={styles.gridLg}>
                <Text
                    color={ColorEnum.Primary700}
                    weight={FontWeightEnum.Bold}
                    size={FontSizeEnum.DisplayXs}
                >{t(screeningSteps.ScreeningIdVerificationFailure.pageTitleTranslationKey)}</Text>
                <Card elevated>
                    <div className={styles.gridMd}>
                        <Text
                            size={FontSizeEnum.Md}
                            weight={FontWeightEnum.Bold}
                            color={ColorEnum.Gray800}
                        >{t('screening.idVerification.idAnalyzerLoading.header')}{dots}</Text>
                        <div className={classNames(styles.textLeft, styles.gridMd)}>
                            <Text color={ColorEnum.Gray800}
                            >{t('screening.idVerification.idAnalyzerLoading.text')}</Text>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default IdAnalyzerLoading;
